import { getHistory } from 'quartz-routing/service';
import { PublicApp } from './PublicApp';
import { jsx as _jsx } from "react/jsx-runtime";
export const getLocaleInfo = () => {
  const loc = window.location;
  let i18nLang = 'en';
  const langMatch = loc.pathname.match(/^\/(de|es|fr|it|ja|nl|fi|da|no|pl|sv|pt|zh-tw|zh-cn|zh|th|ko)\/?/);
  if (langMatch) {
    const lang = langMatch[1];
    if (lang === 'pt') {
      i18nLang = 'pt-br';
    } else if (lang === 'zh' || lang === 'zh-tw') {
      i18nLang = 'zh-tw';
    } else if (lang === 'zh-cn') {
      i18nLang = 'zh-cn';
    } else if (lang === 'no') {
      i18nLang = 'no-no';
    } else {
      i18nLang = lang;
    }
  }
  return {
    locale: i18nLang,
    langEnabled: true
  };
};
export const prepareApp = () => {
  return {
    props: {}
  };
};
export function AppComponent() {
  return /*#__PURE__*/_jsx(PublicApp, {
    history: getHistory()
  });
}